import { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  components: {
      Button: {
          borderRadius: 4,  // или любое другое значение
      }
  }
};